import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[utc-content-host]' })
export class ContentHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
